module.exports = __webpack_public_path__ + "static/media/nowinsg-portrait.61625b81.png";